import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Sticker, { StickerVariants } from './Sticker';
import { FormattedNumber } from 'react-intl';

const MPTokenTag = (props) => {
    const {
        mpt_issuance_id,
        Ticker,
        AssetScale,
        className,
    } = props;

    const value = AssetScale > 0 ? props.children / (10**AssetScale) : props.children;

  return (
    <span className={`text-nowrap ${className}`}>
        <Sticker variant={StickerVariants.LIGHT_BLUE} className="sticker-prefix">MPT</Sticker>
        <Sticker variant={StickerVariants.WHITE} className="sticker-prefix">
        {value >= 0 &&
            <FormattedNumber
                value={value}
                maximumFractionDigits={AssetScale}
                minimumFractionDigits={AssetScale}
            />
        }
        </Sticker>
        <Sticker variant={StickerVariants.WHITE} className="sticker-suffix">
            <Link to={`/mpt/${mpt_issuance_id}`}>
            { Ticker && `$${Ticker}` }
            {!Ticker && mpt_issuance_id?.substring(0,6)}
            </Link>
        </Sticker>
    </span>
  );
}

MPTokenTag.defaultProps = {
  AssetScale: 0,
  className: "",
}

MPTokenTag.propTypes = {
    mpt_issuance_id: PropTypes.string.isRequired,
    Ticker: PropTypes.string,
    AssetScale: PropTypes.number,
    className: PropTypes.string,
}

export default MPTokenTag;